if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      let coach_membership_totals = ""
      let membership_quantity = this.form.querySelector('[name=coach_membership_quantity]').value
      let coach_membership
      let coach_membership_ball_id
      let coach_membership_ball_quantity
      let coach_membership_ball_quantity_1
      let coach_membership_ball_quantity_2
      let coach_membership_ball_sellingPlan
      if (membership_quantity == ""){// just regular membership as a ball+membership bundle
        coach_membership = false
        membership_quantity = 1
      } else {
        coach_membership = true
        coach_membership_ball_id = this.form.querySelector('[name=coach_membership_ball_id]').value
        coach_membership_ball_quantity = this.form.querySelector('[name=coach_membership_ball_quantity]').value
        coach_membership_ball_quantity_1 = coach_membership_ball_quantity.split("+")[0]
        coach_membership_ball_quantity_2 = coach_membership_ball_quantity.split("+")[1]
        coach_membership_ball_sellingPlan = this.form.querySelector('[name=coach_membership_ball_sellingPlan]').value
        let s_plan_name_split = this.form.querySelector('[name=coach_membership_ball_id]').getAttribute("data-ball-name").split("|")
        coach_membership_totals = coach_membership_totals + "<span style='text-transform: uppercase'>" + s_plan_name_split[0].charAt(0).toUpperCase() + s_plan_name_split[0].slice(1) + ":</span><br>" + coach_membership_ball_quantity_1 + "x " + s_plan_name_split[1].charAt(0).toUpperCase() + s_plan_name_split[1].slice(1) + "<br>" + coach_membership_ball_quantity_2 + "x " + s_plan_name_split[2].charAt(0).toUpperCase() + s_plan_name_split[2].slice(1)
      }
      let customProperties = false
      if (this.form.querySelector('[id=customProperties]')){
        customProperties = true
      }
      let selling_plan_membership
      let membership = this.form.querySelector('[name=id_membership]').value
      let discount_code = this.form.querySelector('[name=discount_code]').value
      let instant_checkout = document.querySelector('#submit_products').classList.contains('instant_checkout')
      if (membership == ""){
        membership = false
      } else {
        selling_plan_membership = parseInt(this.form.querySelector('[name=selling_plan_membership]').value)
        coach_membership_totals = membership_quantity + "x " + this.form.querySelector('[name=id_membership]').getAttribute("data-mem-name")+" <br>"+coach_membership_totals
      }
      let ball_id = this.form.querySelector('[name=id]').value;

      if (instant_checkout && instant_checkout != ""){

          let ball_id = this.form.querySelector('[name=id]').value;
          let bundle_timecode = this.form.querySelector('[id=customProperties]').value;
          let get_checkout_link = create_checkout_link(ball_id,membership,selling_plan_membership,discount_code,bundle_timecode);
          window.location = get_checkout_link;
          return;

      }
      else {

          fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {
                  if (response.status) {
                      this.handleErrorMessage(response.description);
                      return;
                  }
                  const mainProduct_response = response;
                  //console.log( JSON.stringify(response.properties['Membership connected with a product']) )
                  let property
                  if (coach_membership == false && membership != false) {
                      property = mainProduct_response.properties['Membership connected with a product'];
                  } else {
                      property = "";
                  }

                  if (membership) {
                      let formData_mem = {
                          'items': [{
                              'id': membership,
                              'properties': {'Sold with ball': property},
                              'quantity': membership_quantity,
                              'selling_plan': selling_plan_membership,
                          }]
                      };

                      fetch('/cart/add.js', {
                          method: 'POST',
                          headers: {
                              'Content-Type': 'application/json'
                          },
                          body: JSON.stringify(formData_mem)
                      })
                          .then((response) => response.json())
                          .then((response) => {

                              if (coach_membership_ball_quantity_1) {
                                  let formData_mem_ball_1 = {
                                      'items': [{
                                          'id': coach_membership_ball_id,
                                          'quantity': coach_membership_ball_quantity_1,
                                      }]
                                  };
                                  fetch('/cart/add.js', {
                                      method: 'POST',
                                      headers: {
                                          'Content-Type': 'application/json'
                                      },
                                      body: JSON.stringify(formData_mem_ball_1)
                                  })
                                      .then((response) => response.json())
                                      .then((response) => {
                                          if (coach_membership_ball_quantity_2) {
                                              console.log(coach_membership_ball_quantity_2)
                                              let formData_mem_ball_2 = {
                                                  'items': [{
                                                      'id': coach_membership_ball_id,
                                                      'quantity': coach_membership_ball_quantity_2,
                                                      'selling_plan': coach_membership_ball_sellingPlan,
                                                  }]
                                              };
                                              fetch('/cart/add.js', {
                                                  method: 'POST',
                                                  headers: {
                                                      'Content-Type': 'application/json'
                                                  },
                                                  body: JSON.stringify(formData_mem_ball_2)
                                              })
                                                  .then((response) => response.json())
                                                  .then((response) => {
                                                      const membership_response = response.items[0].title;
                                                      const ball_quantity = Number(coach_membership_ball_quantity_1) + Number(coach_membership_ball_quantity_2)
                                                      this.cartNotification.renderContents(mainProduct_response, membership_response, membership_quantity, ball_quantity, coach_membership_totals);
                                                  })
                                          }
                                      })
                              } else {
                                  const membership_response = response.items[0].title;
                                  this.cartNotification.renderContents(mainProduct_response, membership_response, membership_quantity, 0, false);
                              }

                          })

                  } else {
                      if (customProperties && !membership) {// only ball when "No membership" has been clicked
                          submitButton.setAttribute('aria-disabled', true);
                          submitButton.classList.add('loading');
                          window.location = "/cart";
                      } else {
                          this.cartNotification.renderContents(mainProduct_response, false, false, false, false);
                      }
                  }
              })
              .catch((e) => {
                  console.error(e);
              })
              .finally(() => {
                  if (customProperties && !membership) {// only ball when "No membership" has been clicked
                  } else {
                      submitButton.classList.remove('loading');
                      submitButton.removeAttribute('aria-disabled');
                      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
                  }

              });
        }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
function create_checkout_link(ball_id, membership,selling_plan_membership,discount_code,bundle_timecode){
    let domain_str = window.location.origin;
    var url = `${domain_str}/cart/add?items[][id]=${ball_id}&items[][quantity]=1&items[][id]=${membership}&items[][properties:123]=${bundle_timecode}&items[][quantity]=1&items[][selling_plan]=${selling_plan_membership}&return_to=/checkout`;
    if (discount_code && discount_code != "") {
       url += `?discount=${discount_code}`
    }
    return url;
}